import { SettingsConfiguration, syncSettingsConfiguration } from '@msdk/definitions'
import { selector } from 'recoil'

import { $refToken } from '../auth'
import { $apiClient } from '../core'

export const $settingsConfiguration = selector({
  key: 'SettingsConfiguration',
  get: async ({ get }) => {
    const client = get($apiClient)
    const token = get($refToken)

    /**
     * this selector could be accessed too early and the user could
     * not be authenticated yes this is why this check is in place
     */
    if (token) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res = await client.read<any>('CMPS/api/Composer/GetSettings')
        const settingsConfiguration = res as SettingsConfiguration
        syncSettingsConfiguration(settingsConfiguration)
        return settingsConfiguration
      } catch (err) {
        console.warn(
          '[settingsConfiguration] error while getting settings configuration, proceding with defaults!',
          err,
        )
        return {
          tokenValidity: undefined,
          userLockMaxAttempts: undefined,
          userLockTimeSpan: undefined,
          userPasswordExpiration: undefined,
          adminPasswordExpiration: undefined,
          mfaEnabled: undefined,
          inactivityTimeout: undefined,
        }
      }
    }
  },
})
